(function () {
  'use strict';

  function initProductModalSlider() {
    const modals = document.querySelectorAll(
      'product-modal.custom-product-media-modal'
    );

    if (!modals.length) return;

    modals.forEach(function (modal) {
      if (modal.dataset.customSliderInitialized === 'true') return;

      const slider = modal.querySelector('[data-product-slider]');
      const track = modal.querySelector('[data-slider-track]');
      const slides = modal.querySelectorAll('[data-slider-slide]');
      const prevButton = modal.querySelector('[data-slider-prev]');
      const nextButton = modal.querySelector('[data-slider-next]');
      const currentCounter = modal.querySelector('[data-slider-current]');
      const dots = modal.querySelectorAll('[data-slider-dot]');

      if (!slider || !track || !slides.length) return;

      modal.dataset.customSliderInitialized = 'true';

      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      /*
       * ---------------------------------------
       * GO TO SLIDE
       * ---------------------------------------
       */
      function goToSlide(index, animate = true) {
        if (!slides.length) return;

        if (index < 0) {
          index = slides.length - 1;
        }

        if (index >= slides.length) {
          index = 0;
        }

        currentIndex = index;

        const slide = slides[currentIndex];

        if (!slide) return;

        const left = slide.offsetLeft;

        track.scrollTo({
          left: left,
          behavior: animate ? 'smooth' : 'auto'
        });

        updateUI();
      }

      /*
       * ---------------------------------------
       * UPDATE COUNTER / DOTS
       * ---------------------------------------
       */
      function updateUI() {
        if (currentCounter) {
          currentCounter.textContent = currentIndex + 1;
        }

        dots.forEach(function (dot, index) {
          dot.classList.toggle(
            'is-active',
            index === currentIndex
          );
        });
      }

      /*
       * ---------------------------------------
       * PREVIOUS
       * ---------------------------------------
       */
      if (prevButton) {
        prevButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          goToSlide(currentIndex - 1);
        });
      }

      /*
       * ---------------------------------------
       * NEXT
       * ---------------------------------------
       */
      if (nextButton) {
        nextButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          goToSlide(currentIndex + 1);
        });
      }

      /*
       * ---------------------------------------
       * DOTS
       * ---------------------------------------
       */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const index = parseInt(
            dot.getAttribute('data-slider-dot'),
            10
          );

          goToSlide(index);
        });
      });

      /*
       * ---------------------------------------
       * MOBILE TOUCH / SWIPE
       * ---------------------------------------
       */
      track.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches.length) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;

          isDragging = true;
        },
        {
          passive: true
        }
      );

      track.addEventListener(
        'touchend',
        function (event) {
          if (!isDragging) return;

          isDragging = false;

          if (!event.changedTouches || !event.changedTouches.length) {
            return;
          }

          const endX = event.changedTouches[0].clientX;
          const endY = event.changedTouches[0].clientY;

          const diffX = endX - startX;
          const diffY = endY - startY;

          /*
           * Only count horizontal swipes.
           */
          if (Math.abs(diffX) < 50) return;

          if (Math.abs(diffX) < Math.abs(diffY)) return;

          if (diffX < 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        },
        {
          passive: true
        }
      );

      /*
       * ---------------------------------------
       * KEYBOARD
       * ---------------------------------------
       */
      modal.addEventListener('keydown', function (event) {
        if (
          event.key === 'ArrowRight' ||
          event.key === 'Right'
        ) {
          event.preventDefault();
          goToSlide(currentIndex + 1);
        }

        if (
          event.key === 'ArrowLeft' ||
          event.key === 'Left'
        ) {
          event.preventDefault();
          goToSlide(currentIndex - 1);
        }
      });

      /*
       * ---------------------------------------
       * DETECT SCROLL POSITION
       * ---------------------------------------
       */
      let scrollTimer = null;

      track.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimer);

          scrollTimer = setTimeout(function () {
            if (!slides.length) return;

            const scrollLeft = track.scrollLeft;

            let closestIndex = 0;
            let closestDistance = Infinity;

            slides.forEach(function (slide, index) {
              const distance = Math.abs(
                slide.offsetLeft - scrollLeft
              );

              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            currentIndex = closestIndex;

            updateUI();
          }, 50);
        },
        {
          passive: true
        }
      );

      /*
       * ---------------------------------------
       * FIND CLICKED PRODUCT IMAGE
       * ---------------------------------------
       */
      function findClickedMedia() {
        const gallery = document.querySelector(
          'media-gallery'
        );

        if (!gallery) return null;

        /*
         * Dawn stores media id on gallery slides.
         */
        const activeSlide = gallery.querySelector(
          '.product__media-item.is-active'
        );

        if (!activeSlide) return null;

        let mediaId = activeSlide.getAttribute(
          'data-media-id'
        );

        if (!mediaId) return null;

        /*
         * Dawn uses section-id-media-id.
         * Remove section prefix if required.
         */
        const parts = mediaId.split('-');

        if (parts.length > 1) {
          mediaId = parts[parts.length - 1];
        }

        return mediaId;
      }

      /*
       * ---------------------------------------
       * OPEN MODAL
       * ---------------------------------------
       */
      function positionFromGallery() {
        const mediaId = findClickedMedia();

        if (!mediaId) {
          goToSlide(0, false);
          return;
        }

        let foundIndex = -1;

        slides.forEach(function (slide, index) {
          if (
            String(
              slide.getAttribute('data-media-id')
            ) === String(mediaId)
          ) {
            foundIndex = index;
          }
        });

        if (foundIndex >= 0) {
          goToSlide(foundIndex, false);
        } else {
          goToSlide(0, false);
        }
      }

      /*
       * ---------------------------------------
       * LISTEN FOR IMAGE CLICK
       * ---------------------------------------
       */
      document.addEventListener(
        'click',
        function (event) {
          const mediaElement =
            event.target.closest(
              '.product__media-item'
            );

          if (!mediaElement) return;

          /*
           * Give Dawn time to open the modal.
           */
          setTimeout(function () {
            positionFromGallery();
          }, 80);
        },
        true
      );

      /*
       * ---------------------------------------
       * OBSERVE MODAL OPENING
       * ---------------------------------------
       */
      const observer = new MutationObserver(function (
        mutations
      ) {
        mutations.forEach(function (mutation) {
          if (
            mutation.type !== 'attributes' ||
            mutation.attributeName !== 'class'
          ) {
            return;
          }

          if (
            modal.classList.contains('active') ||
            modal.classList.contains('open') ||
            modal.hasAttribute('open')
          ) {
            setTimeout(function () {
              positionFromGallery();
            }, 50);
          }
        });
      });

      observer.observe(modal, {
        attributes: true
      });

      /*
       * ---------------------------------------
       * RESIZE
       * ---------------------------------------
       */
      window.addEventListener('resize', function () {
        goToSlide(currentIndex, false);
      });

      /*
       * ---------------------------------------
       * INITIAL STATE
       * ---------------------------------------
       */
      goToSlide(0, false);
    });
  }

  /*
   * ---------------------------------------
   * INITIALIZE
   * ---------------------------------------
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initProductModalSlider
    );
  } else {
    initProductModalSlider();
  }

  /*
   * ---------------------------------------
   * SHOPIFY SECTION RELOAD
   * ---------------------------------------
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(initProductModalSlider, 100);
    }
  );
})();